<nz-spin class="h-full flex items-center justify-center" *ngIf="isLoading" />
<div *ngIf="!isLoading" class="h-full flex flex-col">
  <div *ngIf="chatMessages?.length" class="flex items-center w-full justify-between gap-8 px-16 py-8 border-b-1 border-solid">
    <div class="text-sm flex flex-row gap-8 items-center ml-8">
      <twaice-fe-svg-icon name="filter" source="tabler" size="13px" />
      Filters
    </div>

    <nz-select
      class="w-[300px]"
      nzAllowClear
      nzPlaceHolder="Filter by Tag"
      [(ngModel)]="selectedTags"
      [nzMaxTagCount]="2"
      nzMode="multiple"
      (ngModelChange)="filterByTag($event)"
    >
      @for (tag of tags; track tag) {
        <nz-option [nzLabel]="tagLabel(tag)" [nzValue]="tag"></nz-option>
      }
    </nz-select>
  </div>
  <div class="overflow-auto p-16 flex-1 min-h-0">
    @for (message of filteredChatMessages; track message.timestamp; let last = $last; let i = $index) {
      <ng-template #messageTemplateRef let-message="message">
        <nz-comment [nzAuthor]="message.userMail" [nzDatetime]="message.timestamp | twDate: 'yyyy-MM-dd HH:mm'">
          <nz-avatar nz-comment-avatar [nzText]="message.userMail[0] | titlecase" class="bg-[#9b9fa8]" />

          <nz-comment-content>
            <div
              #commentContent
              class="flex flex-row items-center justify-between gap-24"
              [class.note-highlight]="isHighlighted(message)"
            >
              <p class="mb-0" [innerHTML]="message.message | chatMentions: authService.getUsername()"></p>
            </div>
          </nz-comment-content>

          <nz-comment-action>
            <div class="flex flex-row items-center">
              <twaice-fe-message-tags [tags]="pillTags(message.tags)" (tagsChanged)="onMessageTagsChanged($event, message)" />
            </div>
          </nz-comment-action>

          <nz-comment-action *ngIf="message.sourceUrl && resolvedAllowSourceLink">
            <div class="flex flex-row gap-8 mr-8">
              <button
                nz-button
                nzSize="small"
                nzType="info"
                (click)="goToSourceUrl(message.sourceUrl)"
                nz-tooltip
                nzTooltipPlacement="top"
                nzTooltipTitle="Go to Dashboard"
                class="flex items-center gap-4 justify-center"
              >
                <twaice-fe-svg-icon class="mt-[-2px]" name="external-link" source="tabler" size="16px" />
              </button>
            </div>
          </nz-comment-action>

          <nz-comment-action>
            <div class="flex flex-row gap-8 mr-8">
              <button
                nz-button
                nzSize="small"
                nzType="info"
                (click)="replyToMessage(message)"
                nz-tooltip
                nzTooltipPlacement="top"
                nzTooltipTitle="Reply"
                class="flex items-center gap-4 justify-center"
              >
                <twaice-fe-svg-icon class="mt-[-2px]" name="message-plus" source="tabler" size="16px" />
              </button>
            </div>
          </nz-comment-action>

          <nz-comment-action>
            <div class="flex flex-row gap-8">
              <button
                *ngIf="authService.getUsername() === message.userMail"
                nz-button
                nzSize="small"
                nzType="info"
                (click)="openDeleteModal(message)"
                nz-tooltip
                nzTooltipPlacement="top"
                nzTooltipTitle="Delete"
                class="flex items-center gap-4 justify-center"
              >
                <twaice-fe-svg-icon class="mt-[-2px]" name="trash" source="tabler" size="16px" />
              </button>
            </div>
          </nz-comment-action>

          @if (hasChildren(message)) {
            @for (child of getChildren(message); track child.timestamp) {
              <ng-template [ngTemplateOutlet]="messageTemplateRef" [ngTemplateOutletContext]="{ message: child }" />
            }
          }
        </nz-comment>
      </ng-template>

      <div *ngIf="sectionHeadingFor(message, i) as heading" class="px-4 pt-8 pb-4 text-sm font-semibold text-primary-text">
        <button
          *ngIf="heading.clickable; else plainHeading"
          type="button"
          class="bg-transparent border-0 p-0 text-sm font-semibold text-primary-text underline cursor-pointer"
          (click)="emitHeadingClick(heading.tag)"
        >
          {{ heading.label }}
        </button>
        <ng-template #plainHeading>{{ heading.label }}</ng-template>
      </div>
      <ng-template [ngTemplateOutlet]="messageTemplateRef" [ngTemplateOutletContext]="{ message }"></ng-template>

      <nz-divider *ngIf="!last" class="my-8"></nz-divider>
    } @empty {
      <nz-empty [nzNotFoundContent]="emptyText"></nz-empty>
    }
  </div>
  <div class="border-t-1 border-solid">
    <ng-container *ngIf="parentMessage">
      <div
        class="ml-[62px] mt-8 mb-[-16px] mr-16 text-sm text-tertiary-text flex flex-row items-center justify-between relative z-10"
      >
        <span>Replying to {{ parentMessage.userMail }} at {{ parentMessage.timestamp | twDate: 'yyyy-MM-dd HH:mm' }}</span>

        <button (click)="replyToMessage(null)" class="flex flex-row gap-8 items-center">
          <twaice-fe-svg-icon name="x" source="tabler" size="16px" />
        </button>
      </div>
    </ng-container>

    <nz-comment class="mx-16">
      <nz-avatar nz-comment-avatar [nzText]="authService.getUsername()[0] | titlecase" class="bg-[#9b9fa8]" />
      <nz-comment-content>
        <nz-form-item class="mb-16">
          <textarea [placeholder]="composerPlaceholder" [(ngModel)]="newMessage" nz-input rows="5"></textarea>
        </nz-form-item>
        <div class="flex gap-16 flex-row items-center">
          <nz-form-item class="mb-0 flex-[1_0_auto]">
            <button nz-button nzType="primary" [nzLoading]="submittingMessage" [disabled]="!newMessage" (click)="postMessage()">
              Add Comment
            </button>
          </nz-form-item>

          <div class="w-full">
            <twaice-fe-message-tags [tags]="pillTags(newTags)" (tagsChanged)="onNewTagsChanged($event)" />
          </div>

          <div *ngIf="resolvedAllowSourceLink" class="flex flex-row gap-8 items-center ml-auto whitespace-nowrap">
            <nz-switch nzSize="small" [(ngModel)]="includeLink"></nz-switch> Include link to current dashboard
          </div>
        </div>
      </nz-comment-content>
    </nz-comment>
  </div>
</div>
